import {
    RequestIdWithWarning,
    replaceRequestId,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';

const commonColumns = [
    RequestIdWithWarning(),
    {
        Header: 'Fecha Creación',
        accessor: 'created_at',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Marca',
        accessor: 'vehiculossolicitud.marca.label',
    },
    {
        Header: 'Linea',
        accessor: 'vehiculossolicitud.linea.label',
    },
];

const requestsListStatus = [
    {
        id: 'en_proceso_ejecutivo',
        label: 'POR COMPLETAR',
        status: 6,
        responsable: true,
        columns: commonColumns,
        buttonAction: [{ name: 'sendUrlClient' }],
    },
    {
        id: 'procesadas_ejecutivo',
        label: 'PROCESADAS',
        status: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 6,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_creacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                //cols.splice(1, 0, DefineDate('creacion'));
                cols.splice(8, 0, StatusWithTooltip);
                cols.splice(9, 0, CausalRequest);

                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
